import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=810e0a0c&scoped=true&"
import script from "./UserManage.vue?vue&type=script&lang=js&"
export * from "./UserManage.vue?vue&type=script&lang=js&"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=810e0a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e0a0c",
  null
  
)

export default component.exports